<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'NLRP' },
                { text: 'Partnership Owner' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Partnership Owner</h3>

        <v-card>
            <v-card-title>
                Daftar Partnership Owner
                <v-spacer></v-spacer>
                <v-btn
                    id="tryout_tambah"
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createPartnership()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tambah Pemilik
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="data"
                :headers="headers"
                :hasDownload="true"
                :has-custom-pagination="false"
                :has-custom-search="true"
                :hasMultiSearch="true"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="total_pages"
                :custom-pagination-total-items="total"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="detailPartnership()"
                v-on:exportClicked="exportTryout()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    filters = $event;
                    doSearch();
                "
                v-on:deleteOnFilter="delByOneFilter($event)"
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import { mapState } from "vuex";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            selectedRow: null,
            total: 0,
            total_pages: 0,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            pagination: {
                perPage: 25,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            data: [],
            problem: [],
            total_problem: 0,
            headers: [
                { text: "Nama Partnership Owner", value: "nama", width: 220 },
                { text: "Pimpinan", value: "pimpinan", width: 200 },
                { text: "Provinsi", value: "provinsi", width: 200 },
                { text: "Alamat", value: "alamat", width: 200 },
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            filters: [],
            params: {
                nama: "",
            },
        };
    },

    watch: {
        pagination() {
            this.fetchData();
        },
    },

    mounted: function () {
        this.fetchData();
        this.fetchListProblem();
    },

    computed: {
        ...mapState(["auth"]),
    },

    methods: {
        fetchData() {
            const context = this;

            if (context.filters.length > 0) {
                context.filters.forEach((filter, index) => {
                    if (filter.key.value === "nama") {
                        context.params.nama = filter.value;
                    }
                });
            }

            const page = context.pagination.currentPage - 1;
            const param = `page=${page}&size=${context.pagination.perPage}&nama=${context.params.nama}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/owners?${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.isLoading = true;
            context.data = [];

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    response.data.list_owner.forEach(function (content, index) {
                        var row = {
                            no: index,
                            id: content.id,
                            nama: content.nama,
                            pimpinan: content.pimpinan,
                            deskripsi: content.deskripsi,
                            identitas_owner: content.identitas_owner,
                            provinsi: content.provinsi,
                            alamat: content.alamat,
                        };

                        context.data.push(row);
                    });

                    context.total = response.data.total_owner;
                    context.total_page = response.data.max_page;
                }
                context.isLoading = false;
            });
        },
        doSearch() {
            var context = this;
            context.pagination.currentPage = 1;
            this.fetchData();
        },
        delByOneFilter(filter) {
            this.clearFilter();
            filter.value = "";

            const index = this.filters.push(filter) - 1;
            this.fetchData();
            this.filters.splice(index, 1);
        },
        clearFilter() {
            this.params = {
                nama: null,
            };
        },
        createPartnership() {
            if (this.auth.scopes.includes("admin_itembank")) {
                this.$router.push({ path: "/partnership-owner-form" });
            } else {
                this.$store.commit("showAlert", {
                    message: `Anda tidak memiliki akses untuk menambahkan partnership owner`,
                    type: "error",
                });
            }
        },
        detailPartnership() {
            this.$router.push({
                path: "/partnership-owner-form",
                query: { id: this.selectedRow.id },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// PartnershipOwner.vue?fa789cf0